import { useQuery } from 'react-query';
import { useZoneContext } from '../../../../contexts/useZoneContext';

export const useGetCaseStatisticsKey = 'get-case-statistics';

export const useGetCaseStatistics = (enabled: boolean, caseGuid?: string) => {
    const { zoneApiClient } = useZoneContext();
    
    return useQuery({
        queryKey: [useGetCaseStatisticsKey, caseGuid],
        queryFn: async () => {
            const response = await zoneApiClient.getCaseAssessmentCaseStatistics(caseGuid ?? '');

            if (!response.httpResponse.ok) {
                throw new Error('Failed to retrieve the statistics for this case.');
            }
            
            return response.payload;
        },
        enabled: !!caseGuid && enabled,
        cacheTime: Infinity,
        staleTime: Infinity,
    });
}